import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { ButtonImage } from 'components/Buttons/ButtonImage';
import Detail from 'components/Details/DetailDataFacturacion';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import {
  BaseButton,
  ControllerRender,
  DropDownFilter,
  TextInputOnBlur,
} from 'components/InputsMex/inputs';
import Page from 'components/Page';
import FormQr from 'components/QrReader/FormQr';
import {
  urlCatalogosFacQr,
  urlContinuarDataQr,
  urlContinuarRecuperarDataQr,
  urlExtractDataQr,
  urlFindRfcFacQr,
  urlUploadPdfConstancia,
} from 'constants/urls';
import ModalBanner from 'containers/DatosFacturacionQr/ModalBanner';
import { FormularioFact } from 'containers/DatosFacturacionQr/constants';
import useCustomToast from 'hooks/useCustomToasts';
import { Button } from 'primereact/button';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import COLORS from 'utils/constants/COLORS';
import { getQueryParams } from 'utils/funciones';
import Loading from 'wrappers/Loading';

/**
 *
 * @param {*} param0
 * @returns
 */
const FormularioFacturacion = ({
  BreadcrumbRender,
  Back = () => {},
  Next = () => {},
  history,
  personaFisicaHabilitado = true,
  personaMoralHabilitado = true,
}) => {
  const { idPoliza, ramo, codProducto } = getQueryParams();
  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit } = methods;
  const [loading, setLoading] = useState(false);
  const { addWarningToast, addSuccessToast } = useCustomToast();
  const fileInputRef = useRef(null);

  const [displayContinueButton, setDisplayContinueButton] = useState(false);
  const [displayDetailFacturacion, setDisplayDetailFacturacion] = useState(false);
  const [displayScanOptions, setDisplayScanOptions] = useState(false);
  const [validacionesDatos, setValidacionesDatos] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [showLoadingQr, setShowLoadingQr] = useState(false);
  const [dataDeatilContratante, setDataDeatilContratante] = useState([]);
  const [dataDeatilRegimenes, setDataDeatilRegimenes] = useState([]);
  const [msgErrorScanQr, setMsgErrorScanQr] = useState('');
  const [textosAyuda, setTextosAyuda] = useState({});
  const [modalShowBanners, setModalShowBanners] = useState(false);
  const [objImgBanners, setObjImgBanners] = useState({});  
  const [displayLabelQuedeseasRealizar, setdisplayLabelQuedeseasRealizar] = useState(false);

  const [routeProps, setRouteProps] = useState({});
  const regimenesDisponibles = useMemo(() => {    
    return (      
      dataDeatilRegimenes?.map((item) => ({
        label: item.label,
        value: item,
      })) || []
    );
  }, [dataDeatilRegimenes]);
  const tipoPersona = methods.watch('tipoPersona');
  const requiereFactura = methods.watch('requiereFactura');
  const API = ApiKeyFetch.instance();

  const getData = async () => {
    setLoading(true);
    const obj = {
      codigo: 'validacionesConstancia',
      idPoliza: idPoliza,
    };
    const data = await API.post(urlCatalogosFacQr, obj);
    if (data?.transaccion === true) {
      setValidacionesDatos(data?.data?.validaciones);
      setTextosAyuda(data?.data?.textosAyuda);
      setObjImgBanners(data?.data?.banners);
      setModalShowBanners(true);      
    } else {
      addWarningToast('Ha ocurrido un error intente nuevamente');
    }
    await precargaInformacion();
    setLoading(false);
  };

  const precargaInformacion = async () => {
    const obj = {
      idPoliza: idPoliza,
      ramo: ramo || codProducto,
    };
    const data = await API.post(urlContinuarRecuperarDataQr, obj);
    console.log('DATA: ', data?.data);
    setRouteProps(data?.data?.routeProps);
    if (data?.transaccion === true) {
      if (
        data?.data?.accionRealizada &&
        data?.data?.accionRealizada !== FormularioFact.CONSTANTES.ACCION_REALIZADA.MANUAL
      ) {
        setDisplayScanOptions(true);
        setDisplayContinueButton(true);
        setModalShowBanners(false);
        setdisplayLabelQuedeseasRealizar(true)
      }
      if (data?.data?.informacionContratante && data?.data?.regimenArray) {
        setDisplayContinueButton(true);
        setDisplayDetailFacturacion(true);
        setDataDeatilContratante(data?.data?.informacionContratante);        
        setDataDeatilRegimenes(data?.data?.regimenArray);        
        setModalShowBanners(false);
      }
      if (data?.data?.requiereFactura) {
        setDisplayContinueButton(true);
        setModalShowBanners(false);
        if(data?.data?.requiereFactura=='SI'){
          setDisplayScanOptions(true);
          setdisplayLabelQuedeseasRealizar(true)
        }
      }
      if (
        data?.data?.tipoPersona === FormularioFact.CONSTANTES.TIPO_PERSONA.MORAL &&
        data?.data?.accionRealizada === FormularioFact.CONSTANTES.ACCION_REALIZADA.MANUAL
      ) {
        setDisplayContinueButton(true);
        setModalShowBanners(false);
      }
      const state = { ...data?.data };
      state.regimenValue= data?.data?.regimenValue;
    
      methods.reset({ ...state });      
    }
  };

  const onVisualizarRFC = () => {
    const { TIPO_PERSONA, REQUIERE_FACTURA } = FormularioFact.CONSTANTES;

    return (
      tipoPersona === TIPO_PERSONA.MORAL ||
      (tipoPersona === TIPO_PERSONA.FISICA && requiereFactura === REQUIERE_FACTURA.SI)
    );
  };

  const onCargarInformacion = async () => {
    const state = methods.watch();
    let valueRegimenesACtual = dataDeatilRegimenes;
    setDisplayDetailFacturacion(false);
    setDisplayScanOptions(false);
    const obj = {
      rfc: state.rfc,
    };
    setLoading(true);
    const data = await API.post(urlFindRfcFacQr, obj);
    if (data?.transaccion === true && data?.data?.encontroInformacion === true) {
      setDataDeatilContratante(data?.data?.informacionContratante);
      setDataDeatilRegimenes(data?.data?.regimenes ?? []);
      valueRegimenesACtual = data?.data?.regimenes ?? [];
      setDisplayDetailFacturacion(true);
      setDisplayContinueButton(true);
      addSuccessToast('Se ha cargado correctamente la información.');     
      setdisplayLabelQuedeseasRealizar(true) 
    } else if (data?.data?.encontroInformacion === false) {
      addWarningToast(data?.data?.errorMessage);
      //setDisplayScanOptions(true); 
      setdisplayLabelQuedeseasRealizar(false)     
    }
    setDisplayScanOptions(true);      
    setLoading(false);
    // Cargar el primer valor de regimenes
    if (data?.transaccion === true && data?.data?.encontroInformacion === true) {
      state.regimenValue = valueRegimenesACtual[0];
    }
    methods.reset({ ...state });
  };

  const onGuardar = async () => {
    console.log('DATASAVE: ', methods.watch());
    /*let dataEnviar=methods.watch();
    if (Array.isArray(dataEnviar?.regimenes)) {
      dataEnviar.regimenes=dataEnviar?.regimenes[0];
    }*/
    const obj = {
      data: methods.watch(),
      idPoliza: idPoliza,
      ramo: ramo || codProducto,
    };
    setLoading(true);
    const data = await API.post(urlContinuarDataQr, obj);
    if (data?.transaccion === true && data?.data?.continuar === true) {
      onClickNext();
    } else {
      methods.reset({
        ...obj,
      });
      addWarningToast(data?.data?.errorMessage);
    }
    setLoading(false);
  };

  const onScanData = async ({ error, dataScan }) => {
    if (error) {
      console.error('Error al escanear el código QR:', error);
    } else {
      const state = methods.watch();
      let valueRegimenesACtual = dataDeatilRegimenes;
      setLoading(true);
      const obj = {
        idPoliza: idPoliza,
        url: dataScan?.text,
        ramo: ramo || codProducto,
        tipoPersona: state.tipoPersona,
      };
      setMsgErrorScanQr('');
      const data = await API.post(urlExtractDataQr, obj);
      if (data?.transaccion === true && data?.data?.encontroInformacion === true) {
        setModalShow(false);
        setDataDeatilContratante(data?.data?.informacionContratante);
        console.log('DATA33', data?.data);
        setDataDeatilRegimenes(data?.data?.regimenArray ?? []);
        valueRegimenesACtual = data?.data?.regimenArray ?? [];
        setDisplayDetailFacturacion(true);
        setDisplayContinueButton(true);
        state.rfc = data?.data?.rfc ?? '';
      } else {
        setMsgErrorScanQr(data?.data?.errorMessage);
      }
      setLoading(false);
      // Cargar el primer valor de regimenes
      if (data?.transaccion === true && data?.data?.encontroInformacion === true) {
        state.regimenValue = valueRegimenesACtual[0];
      }
      methods.reset({ ...state });
      addSuccessToast('Se ha concluido exitosamente el proceso de carga de información');
    }
  };

  const onIngresarmanualmente = (fromRequiereFactrura = false) => {
    if (fromRequiereFactrura) {
      setDisplayScanOptions(false);
    }
    setDisplayDetailFacturacion(false);
    setDisplayContinueButton(true);
  };

  const resetStatus = () => {
    setDisplayContinueButton(false);
    setDisplayDetailFacturacion(false);
    setDisplayScanOptions(false);
  };

  const onClickNext = () => {
    return history.push(Next(routeProps));
  };

  const onClickAtras = () => {
    return history.push(Back(routeProps));
  };

  const handlePdfFileChange = (e) => {
    const file = e?.target?.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (fileExtension === 'pdf') {
        onExtraerPDF(file);
      } else {
        addWarningToast('Por favor, selecciona un archivo PDF válido.');
        e.target.value = null;
      }
    }
  };

  const onExtraerPDF = async (file) => {
    const state = methods.watch();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('idPoliza', idPoliza);
    formData.append('ramo', ramo || codProducto);
    formData.append('tipoPersona', tipoPersona);

    setLoading(true);
    const data = await API.postFile(urlUploadPdfConstancia, formData);
    if (data?.transaccion === true && data?.data?.encontroInformacion === true) {
      setDataDeatilContratante(data?.data?.informacionContratante);
      setDataDeatilRegimenes(data?.data?.regimenArray ?? []);
      setDisplayDetailFacturacion(true);
      setDisplayContinueButton(true);
      state.rfc = data?.data?.rfc ?? '';
      state.regimenValue = data?.data?.regimenArray[0];
      addSuccessToast('Se ha concluido exitosamente el proceso de carga de información');
    } else {
      methods.reset({
        ...methods.watch(),
      });
      addWarningToast(data?.data?.errorMessage);
    }
    setLoading(false);
    methods.reset({ ...state });
  };

  const openFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Loading loading={loading}>
          <Page>
            <ModalBanner 
            showModal={modalShowBanners}
            onCloseModal={() => {
              setModalShowBanners(false);
            }}
            objBanners={objImgBanners}
            />
            {BreadcrumbRender}
            <div className="container">
              <div className="border mx-1 ">
                <form onSubmit={handleSubmit(onGuardar)}>
                  <ControllerRender
                    name="tipoPersona"
                    render={({ onChange, value }) => (
                      <ContainerStructureBase title="¿Es una persona física o moral?">
                        {personaFisicaHabilitado && (
                          <div className="col-md-6 ">
                            <ButtonImage
                              textColor={COLORS.coreBlue}
                              bgColor={COLORS.white}
                              iconClass="pi pi-user"
                              label="Persona Física"
                              onClick={() => {
                                methods.clearErrors('rfc');
                                resetStatus();
                                onChange(FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA);
                              }}
                              selected={FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA === value}
                            />
                          </div>
                        )}
                        {personaMoralHabilitado && (
                          <div className="col-md-6 ">
                            <ButtonImage
                              textColor={COLORS.coreBlue}
                              bgColor={COLORS.white}
                              iconClass="pi pi-home"
                              label="Persona Moral"
                              onClick={() => {
                                methods.clearErrors('rfc');
                                resetStatus();
                                onChange(FormularioFact.CONSTANTES.TIPO_PERSONA.MORAL);
                              }}
                              selected={FormularioFact.CONSTANTES.TIPO_PERSONA.MORAL === value}
                            />
                          </div>
                        )}
                      </ContainerStructureBase>
                    )}
                  />

                  {tipoPersona === FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA && (
                    <ControllerRender
                      name="requiereFactura"
                      render={({ onChange, value }) => (
                        <ContainerStructureBase title="¿Requiere factura?">
                          <div className="row w-100 m-1">
                            <div className="col-md-6 ">
                              <ButtonImage
                                textColor={COLORS.coreBlue}
                                bgColor={COLORS.white}
                                iconClass="pi pi-check"
                                label="Si"
                                onClick={() => {
                                  resetStatus();
                                  onChange(FormularioFact.CONSTANTES.REQUIERE_FACTURA.SI);
                                }}
                                selected={FormularioFact.CONSTANTES.REQUIERE_FACTURA.SI === value}
                              ></ButtonImage>
                            </div>
                            <div className="col-md-6 ">
                              <ButtonImage
                                textColor={COLORS.coreBlue}
                                bgColor={COLORS.white}
                                iconClass="pi pi-times"
                                label="No"
                                onClick={() => {
                                  resetStatus();
                                  onIngresarmanualmente(true);
                                  onChange(FormularioFact.CONSTANTES.REQUIERE_FACTURA.NO);
                                }}
                                selected={FormularioFact.CONSTANTES.REQUIERE_FACTURA.NO === value}
                              ></ButtonImage>
                            </div>
                          </div>
                        </ContainerStructureBase>
                      )}
                    />
                  )}

                  {onVisualizarRFC() && (
                    <ContainerStructureBase title="Ingresa tu Rfc" info={textosAyuda?.rfc}>
                      <div className="row w-100 m-1">
                        <div className="col-md-4 "></div>
                        <div className="col-md-4 ">
                          <SimpleContainer label="" name="rfc" showOk={false}>
                            <TextInputOnBlur
                              inputProps={{
                                name: 'rfc',
                              }}
                              extrasClasses="hide-arrows"
                              rules={{
                                required: 'Este campo es obligatorio',
                                pattern: {
                                  value:
                                    methods.watch('tipoPersona') ==
                                    FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA
                                      ? new RegExp(validacionesDatos?.rfcF?.value)
                                      : new RegExp(validacionesDatos?.rfcM?.value),
                                  message:
                                    methods.watch('tipoPersona') ==
                                    FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA
                                      ? validacionesDatos?.rfcF?.message
                                      : validacionesDatos?.rfcM?.message,
                                },
                                maxLength: {
                                  value: 13,
                                  message: 'Ingrese hasta 13 caracteres',
                                },
                              }}
                            />
                          </SimpleContainer>
                        </div>
                        <div className="col-md-4 "></div>
                      </div>
                      <div className="row w-100 m-1">
                        <div className="col-md-4 offset-md-4 mb-5">
                          <BaseButton
                            textColor="white"
                            bgColor={COLORS.primary}
                            onClick={async () => {
                              let valid = await methods.trigger(['rfc']);
                              if (valid) {
                                onCargarInformacion();
                              }
                            }}
                          >
                            Verificar información{' '}
                          </BaseButton>
                        </div>
                      </div>
                    </ContainerStructureBase>
                  )}                

                  {displayScanOptions && (
                    <ControllerRender
                      name="accionRealizada"
                      render={({ onChange, value }) => (
                        <ContainerStructureBase title={displayLabelQuedeseasRealizar==false?"¿Que deseas realizar?":textosAyuda?.msgRevisarDtosFiscalesActualizados}>
                          <div className={tipoPersona === FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA ? "col-md-4 " : "col-md-6 "}>
                          <ButtonImage
                              textColor={COLORS.coreBlue}
                              bgColor={COLORS.white}
                              iconClass="pi pi-microsoft"
                              label="Scanear QR"
                              onClick={() => {
                                setModalShow(true);
                                onChange(FormularioFact.CONSTANTES.ACCION_REALIZADA.QR);
                              }}
                              selected={FormularioFact.CONSTANTES.ACCION_REALIZADA.QR === value}
                            ></ButtonImage>
                            <FormQr
                              label="Escanear código QR"
                              onAction={onScanData}
                              showModal={modalShow}
                              onCloseModal={() => {
                                setModalShow(false);
                              }}
                              showLoading={showLoadingQr}
                              errorServiceMsg={msgErrorScanQr}
                            />
                          </div>
                          <div className={tipoPersona === FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA ? "col-md-4 " : "col-md-6 "}>
                            <ButtonImage
                              textColor={COLORS.coreBlue}
                              bgColor={COLORS.white}
                              iconClass="pi pi-upload"
                              label="Subir PDF"
                              onClick={(event) => {
                                onChange(FormularioFact.CONSTANTES.ACCION_REALIZADA.PDF);
                                openFileInput(event);
                              }}
                              selected={FormularioFact.CONSTANTES.ACCION_REALIZADA.PDF === value}
                            ></ButtonImage>
                            <input
                              type="file"
                              accept=".pdf"
                              onChange={handlePdfFileChange}
                              ref={fileInputRef}
                              className="d-none"
                            />
                          </div>
                          {tipoPersona === FormularioFact.CONSTANTES.TIPO_PERSONA.FISICA && (
                            <div className="col-md-4 ">
                              <ButtonImage
                                textColor={COLORS.coreBlue}
                                bgColor={COLORS.white}
                                iconClass="pi pi-pencil"
                                label="Ingresar manualmente"
                                onClick={() => {
                                  onIngresarmanualmente();
                                  onChange(FormularioFact.CONSTANTES.ACCION_REALIZADA.MANUAL);
                                }}
                                selected={FormularioFact.CONSTANTES.ACCION_REALIZADA.MANUAL === value}
                              ></ButtonImage>
                            </div>
                          )}
                          
                        </ContainerStructureBase>
                      )}
                    />
                  )}

                  {displayDetailFacturacion && (
                    <Detail label="Datos del contratante" data={dataDeatilContratante}>
                      {dataDeatilRegimenes && dataDeatilRegimenes.length > 0 && (
                        <div className="row m-3">
                          <div className="col-md-4 ">
                            <h3 className="text-mex">Regímenes: </h3>
                          </div>
                          <div className="col-md-6 detail-font ">
                            <SimpleContainer name="regimenValue" showOk={false}>
                              <DropDownFilter
                                name="regimenValue"
                                options={regimenesDisponibles}
                                rules={{
                                  required: 'Este campo es obligatorio',
                                }}
                              />
                            </SimpleContainer>
                          </div>
                        </div>
                      )}
                    </Detail>
                  )}

                  {displayContinueButton && (
                    <div className="row mt-4">
                      <div className="col-md-4 offset-md-2">
                        <BaseButton
                          onClick={onClickAtras}
                          type="button"
                          textColor="white"
                          bgColor={COLORS.primary}
                        >
                          <i
                            className="pi pi-arrow-left"
                            style={{ position: 'relative', top: '1px', fontSize: '1.4rem' }}
                          />{' '}
                          Atrás
                        </BaseButton>
                      </div>

                      <div className="col-md-4 ">
                        <BaseButton type="submit" textColor="white" bgColor={COLORS.primary}>
                          Continuar{' '}
                          <i
                            className="pi pi-arrow-right"
                            style={{ position: 'relative', top: '1px', fontSize: '1.4rem' }}
                          />
                        </BaseButton>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </Page>
        </Loading>
      </FormProvider>
    </React.Fragment>
  );
};

export default FormularioFacturacion;

const ContainerStructureBase = ({ title = '', info = '', children }) => {
  return (
    <div className="row justify-content-center px-5">
      <div className="col-md-12 mt-3">
        <h2 className="text-center text-mex">
          {title}{' '}
          {info !== '' && (
            <Button
              type="button"
              label=""
              icon={'pi pi-question'}
              tooltip={info}
              className="btn-info-label"
              tooltipOptions={{ position: 'top' }}
              style={{ marginBottom: '0.4rem', marginLeft: '0.4rem' }}
            />
          )}
        </h2>
      </div>
      {children}
    </div>
  );
};
